export const AUTOMATION_CONTEXT_STEP = 'step';
export const AUTOMATION_CONTEXT_OUTCOME = 'outcome';

export function automationCategoryFilterType(category) {
    return category === AUTOMATION_CONTEXT_OUTCOME ? 'outcome' : 'applicant_step';
}

export const OUTCOME_ROW_ICON_CLASS = {
    5: 'icon-svg-x-circle',
    10: 'icon-svg-user-x-01',
    11: 'icon-svg-trophy-01',
};

export function categorizeAutomationRules(automationRules) {
    const byStep = {};
    const byOutcome = {};
    for (const rule of automationRules || []) {
        if (rule.applicant_step) {
            const sid = rule.applicant_step;
            if (!byStep[sid]) {
                byStep[sid] = [];
            }
            byStep[sid].push(rule);
        }
        if (rule.outcome != null && rule.outcome !== '') {
            const oid = rule.outcome;
            if (!byOutcome[oid]) {
                byOutcome[oid] = [];
            }
            byOutcome[oid].push(rule);
        }
    }
    return { rulesByStep: byStep, rulesByOutcome: byOutcome };
}